import React from 'react';
import format from 'string-template';

import {
  HeaderRow,
  TitleContainer,
  SubTitle,
  Title,
} from '../../../components/v2/Header';
import { PrimaryButton } from '../../../components/Button/ActionButtons';

import UploadDropZone from './components/UploadDropZone';
import DeployItem from './components/DeployItem';
import DeployHistory from './components/DeployHistory';
import useDeployQueue from './hooks/useDeployQueue';
import useNetlifySites from './hooks/useNetlifySites';
import {
  Container,
  SectionHeader,
  SectionTitle,
} from './styles';
import texts from './texts.json';

/**
 * Staff tool: upload Webflow export ZIPs, check them, and deploy each to a Netlify site — the
 * one it was last deployed to, pre-selected, or a new one. Deploys run server-side
 * (functions-22 webflowDeployer) and are followed through their webflowDeploys documents.
 */
const WebflowDeployer = () => {
  const { sites, isLoading: isLoadingSites, error: sitesError } = useNetlifySites();
  const {
    items,
    readyCount,
    addFiles,
    removeItem,
    setTarget,
    deploy,
    deployAllReady,
  } = useDeployQueue(sites);

  return (
    <Container>
      <HeaderRow>
        <TitleContainer>
          <Title>{texts.title}</Title>
          <SubTitle>{texts.subTitle}</SubTitle>
        </TitleContainer>
      </HeaderRow>
      <UploadDropZone onFiles={addFiles} />
      {items.length > 0 && (
        <>
          <SectionHeader>
            <SectionTitle>{texts.uploadsTitle}</SectionTitle>
            <PrimaryButton
              variant="light"
              size="medium"
              $fitToContent
              disabled={readyCount === 0}
              onClick={deployAllReady}
            >
              {format(texts.deployAll, { count: readyCount })}
            </PrimaryButton>
          </SectionHeader>
          {items.map((item) => (
            <DeployItem
              key={item.runId}
              item={item}
              sites={sites}
              isLoadingSites={isLoadingSites}
              sitesError={sitesError}
              onTargetChange={setTarget}
              onDeploy={deploy}
              onRemove={removeItem}
            />
          ))}
        </>
      )}
      <DeployHistory />
    </Container>
  );
};

export default WebflowDeployer;
